// extracted by mini-css-extract-plugin
export var Description = "K_ch";
export var EditorialGuidelines = "K_cc";
export var GuideLines = "K_cj";
export var Title = "K_cg";
export var container = "K_cd";
export var leftColumn = "K_cf";
export var rightColumn = "K_ck";